export default __webpack_public_path__ + "static/media/arrow-up-gray.39b350a4.svg";